import { Classes, Logo } from '@/imports-files/components/main-area';

function MainArea(props) {
  return (
    <div className={Classes.MainArea}>
        <div className={Classes.MainNav}>

     {/*<Logo />*/}

     </div>
      {props.children}
    </div>
  );
}

export default MainArea;
